// Render a single property value as `{ display, title }`. `display` goes in
// the row; `title` is the full pretty-printed value used as a hover tooltip.
// Strings render flat (no quotes — Stripe / Vercel / AWS metadata convention).
// Type affordance only for non-string primitives so they're not mistaken for
// strings.

type RenderedValue = {
  display: string
  title: string
  // Class hint for the value cell — consumed by PropertyRow.
  variant: 'string' | 'number' | 'boolean' | 'null' | 'json'
}

export const renderValue = (value: unknown): RenderedValue => {
  if (value === null) {
    return { display: 'null', title: 'null', variant: 'null' }
  }
  if (typeof value === 'string') {
    return { display: value, title: value, variant: 'string' }
  }
  if (typeof value === 'number') {
    const s = String(value)
    return { display: s, title: s, variant: 'number' }
  }
  if (typeof value === 'boolean') {
    const s = String(value)
    return { display: s, title: s, variant: 'boolean' }
  }
  // Object / array — one-line stringify for the row, pretty for the tooltip.
  // JSON.stringify can technically throw on circular refs, but values that
  // reach this component went through the API and were JSONB-serialized,
  // so they're guaranteed JSON-compatible.
  return {
    display: JSON.stringify(value),
    title: JSON.stringify(value, null, 2),
    variant: 'json',
  }
}
